import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../shared-styles/flex';
import ALERT_TYPES from '../../../../store/alerts/constants';

export const AlertMessage = styled.h3`
  margin-left: ${(props) => props.theme.spacing(10)};
`;

export const AlertContainer = styled.div`
  background-color: ${(props) => (props.alertType === ALERT_TYPES.success
    ? props.theme.palette.white : props.theme.palette.red[25])};
  color: ${(props) => props.theme.palette.black[100]};
  width: 780px;
  box-shadow: 0px 5px 10px #00000029;
  border-radius: 10px;
  ${FlexNoAlign}
  padding: ${(props) => props.theme.spacing(15)};
`;

export const StatusIconContainer = styled.div`
  padding-right: 0;
`;

export const CloseIconContainer = styled.div`
  margin-left: auto;
  align-items: center;
  padding-top: ${(props) => props.theme.spacing(5)};
  flex: none;
`;
